/*
ModalBox - AJAX modal, originally based on Prototype and script.aculo.us.
Copyright Andrey Okonetchnikov (andrej.okonetschnikow@gmail.com), 2006-2007. All rights reserved.
Modified several times since for Allmoxy.
*/
var stop_observing = [];
if (!window.Modalbox)
	var Modalbox = new Object();

Modalbox.Methods = {
	overrideAlert: false,
	initialized: false,
	active: true,
	options: {
		title: " ",
		overlayClose: true,
		width: 800,
		height: document.viewport.getHeight() * 0.8,
		loadingString: get_language_translation('LANG_PLEASE_WAIT') + '. ' + get_language_translation('LANG_LABEL_LOADING')  + '...',
		closeString: get_language_translation('LANG_CLOSE_WINDOW'),
		ok: false,
		params: {},
		method: 'get',
		autoFocusing: false,
		aspnet: false,
		fullScreen: false,
		closePrompt: null,
		x_click: null,
		transitionDuration: 200
	},
	_options: new Object,

	setOptions: function(options) {
		Object.extend(this.options, options || {});
	},

	_init: function(options) {
		Object.extend(this._options, this.options);
		this.setOptions(options);

		this.MBoverlay = new Element("div", { id: "MB_overlay", "class": "am-scrim" });

		this.MBcaption = new Element("h2", { id: "MB_caption", "class": "am-dialog__title" });
		this.MBclose = new Element("a", { id: "MB_close", "class": "am-dialog__close", title: this.options.closeString, href: "javascript:void(0);" }).update("<span class='fal fa-times'></span>");
		this.MBcontent = new Element("div", { id: "MB_content", "class": "am-dialog__content" }).update(
			this.MBloading = new Element("div", { id: "MB_loading" }).update(this.options.loadingString)
		);

		this.MBdialog = new Element("div", { id: "MB_dialog", "class": "am-dialog", role: "dialog", "aria-modal": "true", "aria-labelledby": "MB_caption" });
		this.MBdialog.insert(this.MBcaption).insert(this.MBclose).insert(this.MBcontent);

		this.MBwindow = new Element("div", { id: "MB_window", "class": "am-dialog-host" });
		if (this.options.fullScreen)
			this.MBwindow.addClassName('fullScreen');
		this.MBwindow.insert(this.MBoverlay).insert(this.MBdialog);

		var pwr = document.getElementById("page_wrapper_responsive");
		var pageWrapper = (typeof(pwr) != 'undefined' && pwr != null) ? pwr : document.getElementById("page_wrapper");
		var injectToEl = this.options.aspnet ? $(document.body).down('form') : $(pageWrapper);
		injectToEl.insert({ 'top': this.MBwindow });

		this.hideObserver = this._hide.bindAsEventListener(this);
		this.kbdObserver = this._kbdHandler.bindAsEventListener(this);
		this._initObservers();

		this.initialized = true;
	},

	show: function(content, options) {
		if(!this.initialized) this._init(options);

		this.content = content;
		this.setOptions(options);

		if(this.options.title) {
			$(this.MBcaption).update(this.options.title).show();
		} else {
			$(this.MBcaption).hide();
		}

		if(!this.MBwindow.hasClassName('is-open')) {
			this._appear();
			this.event("onShow");
		} else {
			this._update();
			this.event("onUpdate");
		}
	},

	hide: function(options) {
		if(this.initialized) {
			if(options && typeof options.element != 'function') Object.extend(this.options, options);
			this.event("beforeHide");
			this.MBwindow.removeClassName('is-open');
			setTimeout(this._deinit.bind(this), this.options.transitionDuration);
		} else throw("Modalbox is not initialized.");
	},

	_hide: function(event) {
		if(event && event.stop) event.stop();
		if(event && event.element && event.element().id == 'MB_overlay') {
			if(!this.options.overlayClose) return false;
			if(this.options.closePrompt && !confirm(this.options.closePrompt)) return false;
		}
		this.hide();
		if(this.options.x_click)
			this.options.x_click();
	},

	alert: function(message){
		var html = '<div class="MB_alert"><p>' + message + '</p><button type="button" class="am-btn am-btn--filled" onclick="Modalbox.hide()">OK</button></div>';
		Modalbox.show(html, {title: 'Alert: ' + document.title, width: 300});
	},

	_appear: function() {
		this._setSize();
		this.MBwindow.offsetHeight;
		this.MBwindow.addClassName('is-open');
		this.loadContent();
	},

	resize: function(byWidth, byHeight, options) {
		if(options) this.setOptions(options);
		if(!this.options.fullScreen && byWidth) {
			var w = parseInt(this.MBdialog.getStyle('width')) || this.options.width;
			this.MBdialog.setStyle({ width: (w + byWidth) + "px" });
		}
		setTimeout(function() {
			this.event("_afterResize");
			this.event("afterResize");
		}.bind(this), 1);
	},

	resizeToContent: function(options){
		if(options) this.setOptions(options);
		this.event("_afterResize");
		this.event("afterResize");
	},

	resizeToInclude: function(element, options){
		if(options) this.setOptions(options);
		this.event("afterResize");
	},

	_update: function() {
		$(this.MBcontent).update("");
		this.MBcontent.appendChild(this.MBloading);
		$(this.MBloading).update(this.options.loadingString);
		this._setSize();
		this.loadContent();
	},

	loadContent: function () {
		if(this.event("beforeLoad") != false) {
			if(typeof this.content == 'string') {
				var htmlRegExp = new RegExp(/<\/?[^>]+>/gi);
				if(htmlRegExp.test(this.content)) {
					this._insertContent(this.content.stripScripts());
					this._putContent(function(){
						this.content.extractScripts().map(function(script) {
							return eval(script.replace("<!--", "").replace("// -->", ""));
						}.bind(window));
					}.bind(this));
				}
				else {
					new Ajax.Request( this.content, { method: this.options.method.toLowerCase(), parameters: this.options.params,
						onSuccess: function(transport) {
							var response = new String(transport.responseText);
							this._insertContent(transport.responseText.stripScripts());
							this._putContent(function(){
								response.extractScripts().map(function(script) {
									return eval(script.replace("<!--", "").replace("// -->", ""));
								});
							});
						}.bind(this),
						onFailure: function(){
							window.location.reload();
						},
						onException: function(instance, exception){
							Modalbox.hide();
							throw('Modalbox Loading Error: ' + exception);
						}
					});
				}
			} else if (typeof this.content == 'object') {
				this._insertContent(this.content);
				this._putContent();
			} else {
				Modalbox.hide();
				throw('Modalbox Parameters Error: Please specify correct URL or HTML element (plain HTML or object)');
			}
		}
	},

	_insertContent: function(content){
		$(this.MBcontent).hide().update("");
		var ok_button = this.options.ok ? '<div class="am-dialog__actions"><button type="button" class="am-btn am-btn--filled" onclick="Modalbox.hide();">Okay</button></div>' : '';
		if(typeof content == 'string') {
			setTimeout(function() {
				this.MBcontent.update(content + ok_button);
			}.bind(this), 1);
		} else if (typeof content == 'object') {
			var _htmlObj = content.cloneNode(true);
			if(content.id) content.id = "MB_" + content.id;
			$(content).select('*[id]').each(function(el){ el.id = "MB_" + el.id; });
			this.MBcontent.appendChild(_htmlObj);
			this.MBcontent.down().show();
		}
	},

	_putContent: function(callback){
		this.MBcontent.show();
		this._setFocus();
		setTimeout(function(){
			if(callback != undefined)
				callback();
			this.event("afterLoad");
		}.bind(this), 1);
	},

	activate: function(options){
		this.setOptions(options);
		this.active = true;
		$(this.MBclose).observe("click", this.hideObserver);
		if(this.options.overlayClose)
			$(this.MBoverlay).observe("click", this.hideObserver);
		$(this.MBclose).show();
	},

	deactivate: function(options) {
		this.setOptions(options);
		this.active = false;
		$(this.MBclose).stopObserving("click", this.hideObserver);
		if(this.options.overlayClose)
			$(this.MBoverlay).stopObserving("click", this.hideObserver);
		$(this.MBclose).hide();
	},

	_initObservers: function(){
		$(this.MBclose).observe("click", this.hideObserver);
		if(this.options.overlayClose)
			$(this.MBoverlay).observe("click", this.hideObserver);
		if(Prototype.Browser.IE)
			Event.observe(document, "keydown", this.kbdObserver);
		else
			Event.observe(document, "keypress", this.kbdObserver);
	},

	_removeObservers: function(){
		$(this.MBclose).stopObserving("click", this.hideObserver);
		if(stop_observing && stop_observing.length){
			stop_observing.each(function(fn){ fn(); });
			stop_observing = [];
		}
		if(this.options.overlayClose)
			$(this.MBoverlay).stopObserving("click", this.hideObserver);
		if(Prototype.Browser.IE)
			Event.stopObserving(document, "keydown", this.kbdObserver);
		else
			Event.stopObserving(document, "keypress", this.kbdObserver);
	},

	_setFocus: function() {
		if(this.focusableElements().length > 0 && this.options.autoFocusing == true) {
			var firstEl = this.focusableElements().find(function (el){ return el.tabIndex == 1; }) || this.focusableElements().first();
			firstEl.focus();
		} else {
			if ($(this.MBclose).visible()) $(this.MBclose).focus();
		}
	},

	focusableElements: function(){
		this.MBcontent.select('input[type=button],input[type=checkbox],input[type=image],input[type=password],input[type=radio],input[type=reset],input[type=submit],input[type=text], select, textarea, button, a[href]').invoke('addClassName', 'MB_focusable');
		return this.MBcontent.select('.MB_focusable');
	},

	_kbdHandler: function(event) {
		var node = event.element();
		switch(event.keyCode) {
			case Event.KEY_TAB:
				event.stop();
				if(!event.shiftKey) {
					if(this.focusableElements().indexOf($(node)) == this.focusableElements().length - 1)
						this.focusableElements().first().focus();
					else
						this.focusableElements()[this.focusableElements().indexOf($(node))+1].focus();
				} else {
					if(this.focusableElements().indexOf($(node)) <= 0) {
						this.focusableElements().last().focus();
					} else {
						var new_focus = this.focusableElements()[this.focusableElements().indexOf($(node)) -1];
						while(!is_visible(new_focus)){
							new_focus = this.focusableElements()[this.focusableElements().indexOf($(new_focus)) -1]
						}
						new_focus.focus();
					}
				}
				break;
			case Event.KEY_ESC:
				if(this.active) this._hide(event);
				break;
			case 32:
				this._preventScroll(event);
				break;
			case 0:
				if(event.which == 32) this._preventScroll(event);
				break;
		}
	},

	_preventScroll: function(event) {
		if(!["input", "textarea", "select", "button"].include(event.element().tagName.toLowerCase()))
			event.stop();
	},

	_deinit: function() {
		this._removeObservers();
		this._removeElements();
	},

	_removeElements: function () {
		if(this.MBwindow) $(this.MBwindow).remove();

		if(typeof this.content == 'object' && this.content) {
			if(this.content.id && this.content.id.match(/MB_/))
				this.content.id = this.content.id.replace(/MB_/, "");
			this.content.select('*[id]').each(function(el){ el.id = el.id.replace(/MB_/, ""); });
		}
		this.initialized = false;
		this.event("afterHide");
		this.setOptions(this._options);
	},

	_setSize: function () {
		if(!this.options.fullScreen && this.MBdialog)
			this.MBdialog.setStyle({ width: this.options.width + "px", maxWidth: "92vw" });
	},
	_setPosition: function () {},

	event: function(eventName) {
		if(this.options[eventName]) {
			var returnValue = this.options[eventName]();
			this.options[eventName] = null;
			if(returnValue != undefined)
				return returnValue;
			else
				return true;
		}
		return true;
	}
};

function is_visible(ob){
	if(!ob.visible()) return false;
	while(ob = ob.up()){
		if(ob.tagName.toLowerCase() == 'body')
			return true;
		if(!ob.visible())
			return false;
	}
}
Object.extend(Modalbox, Modalbox.Methods);

if(Modalbox.overrideAlert) window.alert = Modalbox.alert;
